// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__1xM2N","header":"Content_header__9X2bY","footer":"Content_footer__1lDQw","left_bar":"Content_left_bar__3Urtx"};